import './blurb';
import './accordion';
import './testimonials';
import './highlights-carousel';
import './sidebar';
// import './image-gallery';
